import { useEffect, useState } from 'react';

/**
 * Runs a module's lazy `initialize()` and reports its outcome: `null` while it
 * is pending, then the boolean it resolved to. The modules fetch their own
 * index the first time one of their pages is shown, and cache the promise, so
 * this is cheap to call from every page.
 */
const useInitialized = (initialize: () => Promise<boolean>): boolean | null => {
    const [status, setStatus] = useState<boolean | null>(null);
    useEffect(() => {
        let active = true;
        initialize().then((result) => {
            if (active) {
                setStatus(result);
            }
        });
        return () => {
            active = false;
        };
    }, [initialize]);
    return status;
};

export default useInitialized;
